import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import viewCustomer from './view-customer';
const Customers = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/view-customer/:CustomerId`} component={viewCustomer} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default Customers;